import { render, staticRenderFns } from "./CandidatesWaitBtn.vue?vue&type=template&id=b1f050f4&lang=pug"
import script from "./CandidatesWaitBtn.vue?vue&type=script&lang=js"
export * from "./CandidatesWaitBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports